import React, { useEffect } from "react";
import UserHome from "./userhome";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useLocation
} from "react-router-dom";
import Navlinks from "./navlinks";
import Referrals from "./referrals";
import Staking from "./staking";
import Transfer from "./transfer";
import Withdraw from "./withdraw";
import AppContext from "../context/appContext";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useContext } from "react";
import { ConnectKitButton } from "connectkit";
import { config } from "./config";
import { useAccount } from "wagmi";
import { Triangle } from "react-loader-spinner";
// import { useEffect } from "react";
const UserDashboard = () => {
    const location = useLocation();
    const appContext = useContext(AppContext)
    const history = useHistory()
    const { authToken, createAccount, setAuthToken, getUser, userData } = appContext

    const connectedaddress = useAccount(config)

    console.log(connectedaddress.address);

    console.log(connectedaddress);


    // if (!connectedaddress.address) {
    //     setAuthToken(null)
    // }
    if (!authToken) {
        history.push('/sign-in')
    }
    useEffect(() => {

        getUser()
    }, [])

    if (connectedaddress.isConnected) {
        if (userData) {
            if (userData.walletAddress !== connectedaddress.address) {
                setAuthToken(null)
            }
        }
    }




    return (
        <div>
            
            {/* Navbar for mobile */}
            <nav className="navbar navbar-dark bg-dark d-md-none">
                <div className="container-fluid">
                    <button
                        className="btn btn-outline-light"
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#mobileSidebar"
                        aria-controls="mobileSidebar"
                    >
                        ☰ Menu
                    </button>

                    <div className="dropdown">
                        <a
                            href="#"
                            className="d-flex align-items-center text-white text-decoration-none dropdown-toggle"
                            id="dropdownUser1"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            <div className="position-relative">
                                <img
                                    src="https://png.pngtree.com/png-vector/20220529/ourmid/pngtree-black-user-icon-flat-and-simple-vector-people-avatar-icon-vector-png-image_46750236.jpg"
                                    alt="profile"
                                    width="30"
                                    height="30"
                                    className="rounded-circle"
                                />
                                <span class="position-absolute top-0 start-100 translate-middle p-2 bg-success border border-light rounded-circle">
                                    <span class="visually-hidden">New alerts</span>
                                </span>
                            </div>
                            <span className=" d-sm-inline mx-1">{userData && userData.name}</span>
                        </a>
                        <ul className="dropdown-menu dropdown-menu-dark dropdown-menu-end text-small shadow">
                            <li>
                                <a className="dropdown-item" href="#">
                                    <ConnectKitButton showAvatar={false} />

                                </a>
                            </li>

                            {/* <li>
                                <div onClick={() => { setAuthToken(null) }} className="dropdown-item" >
                                    Sign out
                                </div>
                            </li> */}
                        </ul>
                    </div>
                </div>
            </nav>

            <div className="container-fluid">
                <div className="row flex-nowrap">
                    {/* Sidebar for larger screens */}
                    <div style={{ position: "sticky", height: "100vh", top: 0 }} className="col-auto col-md-3 col-xl-2 px-sm-2 px-0 bg-dark d-none d-md-block">
                        <div className="d-flex flex-column align-items-center align-items-sm-start px-3 pt-2 text-white min-vh-100">
                            <a
                                href="/"
                                className="d-flex align-items-center pb-3 mb-md-0 me-md-auto text-white text-decoration-none"
                            >
                                <span className="fs-5 d-none d-sm-inline">Menu</span>
                            </a>
                            <ul
                                className="nav w-100 nav-pills flex-column mb-sm-auto mb-0 align-items-center align-items-sm-start"
                                id="menu"
                            >
                                <Navlinks />
                            </ul>
                            <hr />
                            <div className="dropdown pb-4">
                                <a
                                    href="#"
                                    className="d-flex align-items-center text-white text-decoration-none dropdown-toggle"
                                    id="dropdownUser1"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    <div className="position-relative">
                                        <img
                                            src="https://png.pngtree.com/png-vector/20220529/ourmid/pngtree-black-user-icon-flat-and-simple-vector-people-avatar-icon-vector-png-image_46750236.jpg"
                                            alt="profile"
                                            width="30"
                                            height="30"
                                            className="rounded-circle"
                                        />
                                        <span class="position-absolute top-0 start-100 translate-middle p-2 bg-success border border-light rounded-circle">
                                            <span class="visually-hidden">New alerts</span>
                                        </span>
                                    </div>
                                    <span className="d-none d-sm-inline mx-1">{userData && userData.name}</span>
                                </a>
                                <ul className="dropdown-menu dropdown-menu-dark text-small shadow">
                                    <li>
                                        <div className="dropdown-item">
                                            <ConnectKitButton showAvatar={false} />

                                        </div>
                                    </li>
                                    {/* <hr />
                                    <li>
                                        <a onClick={()=>setAuthToken(null)} className="dropdown-item">
                                            Sign Out

                                        </a>
                                    </li> */}
                                    {/* <li>
                                        <a onClick={() => { setAuthToken(null) }} className="dropdown-item" href="#">
                                            Sign out
                                        </a>
                                    </li> */}
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Offcanvas Sidebar for Mobile */}
                    <div
                        className="offcanvas offcanvas-start bg-dark text-white"
                        id="mobileSidebar"
                        aria-labelledby="mobileSidebarLabel"
                    >
                        <div className="offcanvas-header">
                            <h5 className="offcanvas-title" id="mobileSidebarLabel">
                                Menu
                            </h5>
                            <button
                                type="button"
                                className="btn-close text-reset"
                                data-bs-dismiss="offcanvas"
                                aria-label="Close"
                                style={{ filter: "invert(1)", opacity: 1 }}
                            ></button>
                        </div>
                        <div className="offcanvas-body">
                            <ul className="nav nav-pills flex-column">

                                <Navlinks mobile={true} />
                            </ul>
                        </div>
                    </div>

                    {/* Main Content */}
                    {userData && <div className="col py-3">
                        <Switch>
                            <Route exact path="/user-dashboard">
                                <UserHome />
                            </Route>
                            <Route path="/user-dashboard/staking">
                                <Staking />

                            </Route>
                            <Route path="/user-dashboard/transfer/:to?">
                                <Transfer />

                            </Route>
                            <Route path="/user-dashboard/referrals">
                                {/* <h1>hellworld</h1> */}
                                <Referrals />

                            </Route>
                            <Route path="/user-dashboard/withdraw">
                                <Withdraw />

                            </Route>
                        </Switch>

                    </div>}
                </div>
            </div>
        </div >
    );
};

export default UserDashboard;
